<div class="box">
  <div class="box-title">
    {{ 'Last_test' | translate }}
    <button mat-mini-fab
            color="none"
            class="more-button float-right"
            [matTooltip]="'TestsAll' | translate"
            [routerLink]="'/' + organization?.code + '/athletes/' + athleteUser?.id + '/tests'"
    >
      <mat-icon color="primary">zoom_in</mat-icon>
    </button>
  </div>
  <div class="box-content">
    <mat-spinner [diameter]="30" *ngIf="isLoading; else boxContent"></mat-spinner>
  </div>
</div>


<ng-template #boxContent>

  <div *ngIf="hasFatalError" class="fatal-error-box">
    <mat-icon class="no-data-icon">sentiment_very_dissatisfied</mat-icon>
    <div class="no-data">{{ 'No_data' | translate }}</div>
  </div>

  <div class="test-container" *ngIf="!hasFatalError">
    <div class="test-date">{{ lastTest.date | appDate:'dd MMM yyyy':'':currentLang }}</div>
    <div class="test-name">{{ lastTest.name }}</div>
    <ng-container *ngFor="let value of lastTest.values">
      <div class="test-bloc">
        <div class="test-bloc-title">{{ value.metric.name }}&nbsp;:&nbsp;</div>
        <div class="test-bloc-value">{{ value.value }} {{ value.metric.test_unit_name }}</div>
      </div>
    </ng-container>
  </div>

</ng-template>
